<template>
    <div>
        <div v-if="checkTime && timeForm.status=='0'">
            <div v-if="ticketForm.status=='1'">
                <div style="text-align: right;margin: auto;margin-right: 200px;margin-top: 30px">
                    <el-button type="primary" @click="downloadResult('mainContent')">导出图片准考证</el-button>
                    <el-button type="primary" @click="printOutpdf('mainContent')">导出PDF准考证</el-button>
<!--                    <el-button type="primary" @click="exportWord">导出word准考证</el-button>-->
<!--                    <el-button type="primary" v-print="'#mainContent'">打印准考证</el-button>-->
                </div>
                <div class="page" id="mainContent" :style="{backgroundImage:(showBa ?`url(${orgBackground})`:'')}">
                    <div style="height: 60px;margin-top: -30px;text-align: center">
                        <h2>{{new Date().getFullYear()}}年湖北省普通高等学校专升本考试考生准考证</h2>
                    </div>
                    <div style="width: 100%;height: auto;">
                        <div style="width: 100%;height: 180px">
                            <div style="width: 80%;float: left;text-align: left">
                                <div class="titleTicket">
                                    <span class="titleSpan" style="">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
                                    <span style="margin-left: 50px;font-size: 20px">{{ticketForm.name}}</span>
                                </div>
                                <div class="titleTicket">
                                    <span class="titleSpan">准考证号：</span>
                                    <span style="margin-left: 50px;font-size: 20px">{{ticketForm.ticketNumber}}</span>
                                </div>
                                <div class="titleTicket">
                                    <span class="titleSpan">身份证号：</span>
                                    <span style="margin-left: 50px;font-size: 20px">{{ticketForm.idCard}}</span>
                                </div>
                            </div>
                            <div style="width: 20%;float: left;">
                                <img style="width: 140px; height: 160px;margin-top: 20px" id="faceImg" src=""/>
                            </div>
                        </div>
                        <table width="100%" border="1" class="table-edit" style="color: #000;font-size: 18px" cellspacing="0" cellpadding="0"  align="center">
                            <tr>
                                <th>考点名称</th>
                                <td colspan="4" style="text-align: left;">武汉晴川学院</td>
                            </tr>
                            <tr>
                                <th>考点地址</th>
                                <td colspan="4" style="text-align: left;">武汉市东湖新技术开发区中华科技产业园玉屏大道9号</td>
                            </tr>
                            <tr>
                                <th>考试日期</th>
                                <th>考试时间</th>
                                <th style="width: 100px">考试科目</th>
                                <th>考场号</th>
                                <th>座位号</th>
                            </tr>
                            <tr v-for="item in ticketForm.majorItemList">
                                <td>{{item.examDay}}</td>
                                <td>{{item.examStartTime}}~{{item.examEndTime}}</td>
                                <td>{{item.name}}</td>
                                <td>{{item.examRoomNum}}</td>
                                <td>{{item.seatNumber}}</td>
                            </tr>
                        </table>
                    </div>
                    <div style="text-align: left;text-indent: 20px;color: #000!important;" v-if="ticketForm && ticketForm.sysMajor" v-html="ticketForm.sysMajor.xz">
<!--                        <div style="font-size: 15px;">（成绩查询时间：2023年5月18日16：00<span style="margin-left: 200px"></span>成绩查询方式：见学校招生信息网公告）</div>-->
<!--                        <div style="font-size: 16px;text-align: center;font-weight: bold;"> 考生须知</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">1.考生应自觉遵守考试纪律，服从考场管理，端正考风，诚信应考。考生不得以任何理由妨碍监考员等考试工作人员履行职责，不得扰乱考点、考场的考试秩序。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">2.考前90分钟，考生应依次排队经智能身份核验通道通过电子设备刷读身份证和头像抓拍，接受人证头像比对智能身份核验，人证比对一致后方可进入候考区等候，待预备铃响后进入考试大楼。持临时身份证或因身份证消磁无法在电子设备刷证的考生以及经电子设备刷证后人证比对不一致的考生，一律经人工通道且人工双人核验通过后方可进入。按照《国家教育考试违规处理办法》（教育部令第33号）第五条规定，考生未经电子身份核验或人工通道双人核验、双人签字，违规进入考场属于违反考场规则的行为，应当认定为考试违纪，取消该科目考试成绩。若考生未能在规定时间内完成身份核验导致无法正常参加考试的，责任和后果由考生本人承担。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">3.考生入场只可携带2B铅笔、黑色字迹的签字笔、无封套橡皮及无商标纸的饮料等规定物品，严禁携带手机等各种带有拍照和无线信号收发功能的电子设备、手表及其他计时工具以及计算器、涂改液、修正带等物品进入考场。考生携带的违禁物品须统一存放在指定的物品存放处。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">4. 9点（14点）开考后，所有迟到考生一律不得进入考场。考前30分钟，考生凭准考证、身份证，在考场前门入口处接受监考员的安全检查和身份核验，通过后进入考场，对号入座，并将准考证、身份证放在课桌左上方，以便查验。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">5.大学英语考试答题前，考生应在试卷和答题卡上先将自己的姓名、报考学校、准考证号、座位号填写清楚，并与准考证条形码上的姓名、准考证号核对，确认一致后从试卷首页撕下试卷条形码，将准考证条形码和试卷条形码分别粘贴在答题卡上指定位置。不按规定粘贴条形码或填写个人信息而引起的一切后果和责任由考生本人承担。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">6.考生必须用规定的文具和规范的语言文字在答题卡上与试卷题号相对应的答题区域内作答，选择题用2B 铅笔填涂，要求涂黑、涂匀、涂实；非选择题用黑色签字笔作答，要求字体工整，笔迹清楚，答题卡应保持整洁，不得乱写、乱涂、乱画，不得弄皱、弄折、弄破。凡在试卷、草稿纸、答题卡答题区域以外作答的内容或在答题卡上做任何与答题无关的特殊标记的答卷，一律作无效处理。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">7.考试时间一律以考点发出的统一司铃讯号为准，考场内挂钟的时间仅供考生掌握时间作参考。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">8.遇试卷、答题卡分发错误及试题字迹不清、重印、漏印或缺页、缺字等问题，在开考前应举手报告监考员；开考后再进行报告的，因更换试卷或答题卡而延误的考试时间不予延长；涉及试题内容的疑问，不得向监考员询问。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">9.开考司铃讯号发出后考生方可开始答题，考试过程中，考生不得中途退场，不得提前交卷离场，否则按违规处理。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">10.考生在考场内须保持安静，不准吸烟，不准喧哗，不准交头接耳、左顾右盼、打手势、做暗号，不准夹带、旁窥、抄袭或有意让他人抄袭，不准胁迫他人为自己抄袭提供方便，不准传抄答案或交换试卷、答题卡、草稿纸，不准传递文具、用品等，不准将本人或他人的试卷、答题卡、草稿纸撕毁或带出考场。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">11.考试结束信号发出后，考生应立即停止答题且不得离开座位，等监考员收齐试卷、答题卡、草稿纸并清点无误后，考生方可离开考场。</div>-->
<!--                        <div style="font-size: 15px;text-align: justify; text-justify:inter-ideograph;">12. 考场视频监控录像资料将作为违规考生处理依据，严禁携带无线通信工具进入考场。如违反考试规定和考场纪律、不服从考试工作人员管理，有违纪、作弊等行为的，将按照《国家教育考试违规处理办法》等法律法规进行处理，并将违规事实记入国家教育考试个人诚信档案。涉嫌代考等违法的，由考点移送当地公安和司法机关，依照《中华人民共和国刑法》及有关法律追究法律责任。</div>-->
                    </div>
                </div>
            </div>
            <div v-else style="width: 600px;text-align: center;margin:auto;margin-top: 100px;">
                <el-card class="box-card" >
                    <div slot="header" class="clearfix">
                        <span style="color: red">提醒</span>
                    </div>
                    <div class="text item" style="color: red">
                        <p>未查到您的参考信息</p>
                        <p>如有疑问请联系学院老师</p>
                    </div>
                </el-card>
            </div>
        </div>
        <div v-else style="width: 600px;text-align: center;margin:auto;margin-top: 100px;">
            <el-card class="box-card" >
                <div slot="header" class="clearfix">
                    <span style="color: red">通知</span>
                </div>
                <div class="text item" style="color: red">
                    <p v-if="timeForm.status=='0'">准考证打印时间为：{{timeForm.startTime}}~{{timeForm.endTime}}</p>
                    <p v-else>准考证打印未开始</p>
                    <p>如有疑问请联系学院老师</p>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import html2canvas from 'html2canvas';
    import JsPDF from 'jspdf'
    import Watermark from '@/util/waterMark';
    let loading;
    export default {
        name: "sysScoreLook",
        components: { noData },
        data() {
            return {
                ticketForm: {
                    faceImg:'',
                },
                config:config,
                ticketTime:'',
                checkTime:'',
                timeForm:{

                },
                orgBackground: "",
                showBa:true,
                printObj: {
                    id: "mainContent",
                    closeCallback:()=>{
                        this.showBa=true   // 取消或者打印成功，返回页面时不显示水印
                        console.log(this.showBa)
                    }
                },
            }
        },
        created(){
            axios({
                url:`${home}/login/checkTicketTime`,
                method:'GET'
            }).then(res=>{
                this.timeForm = res.data;
                this.checkTime = res.data2;
                if(res.data2){
                    this.submit();
                }
            }).catch(error=>{

            })
            this.orgBackground = Watermark.addWaterMark();
        },
        mounted(){
        },
        methods: {
            submit(){
                axios({
                    url:`${home}/sysStudent/getTicket`,
                    method:'GET',
                }).then(res=>{
                    this.ticketForm=res.data;
                    this.getUrlBase64(config.resPre+res.data.faceImg, "jpg", function (base64) {
                        document.getElementById("faceImg").src = base64;
                    });

                }).catch(function (error) {
                    console.log(error);
                });
            },
            dataURLToBlob(dataurl) {//ie 图片转格式
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: mime})
            },
            downloadResult(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let canvasID = document.getElementById(name);
                let a = document.createElement('a');
                let opts = {
                    scale: 3, // 添加的scale 参数
                    logging: false, //日志开关，便于查看html2canvas的内部执行流程
                    useCORS: true, // 【重要】开启跨域配置
                };
                html2canvas(canvasID,opts).then(canvas => {
                    let dom = document.body.appendChild(canvas);
                    dom.style.display = "none";
                    a.style.display = "none";
                    document.body.removeChild(dom);
                    let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
                    a.setAttribute("href", URL.createObjectURL(blob));
                    a.setAttribute("download", this.ticketForm.name + "的准考证.png")
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(blob);
                    document.body.removeChild(a);
                    loading.close();
                });
				        this.saveItem(0);
            },
            /**
             *
             * @param url 图片路径
             * @param ext 图片格式
             * @param callback 结果回调
             */
            getUrlBase64(url, ext, callback) {
                var canvas = document.createElement("canvas");   //创建canvas DOM元素
                var ctx = canvas.getContext("2d");
                var img = new Image;
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = function () {
                    canvas.height = 140; //指定画板的高度,自定义
                    canvas.width = 150; //指定画板的宽度，自定义
                    ctx.drawImage(img, 0, 0, 140, 150); //参数可自定义
                    var dataURL = canvas.toDataURL("image/" + ext);
                    callback.call(this, dataURL); //回掉函数获取Base64编码
                    canvas = null;
                };

            },
            printOut(name) {
                // 个人观察只是截取可见范围以及以下的区域，所以先将滚动条置顶
                $(window).scrollTop(0); // jQuery 的方法
                document.body.scrollTop = 0; // IE的
                document.documentElement.scrollTop = 0; // 其他
                this.downloadResult(name)
            },
            printOutpdf(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let shareContent = document.getElementById(name),//需要截图的包裹的（原生的）DOM 对象
                    width = shareContent.clientWidth, //获取dom 宽度
                    height = shareContent.clientHeight, //获取dom 高度
                    canvas = document.createElement("canvas"), //创建一个canvas节点
                    scale = 3; //定义任意放大倍数 支持小数
                canvas.width = width * scale; //定义canvas 宽度 * 缩放
                canvas.height = height * scale; //定义canvas高度 *缩放
                canvas.style.width = shareContent.clientWidth * scale + "px";
                canvas.style.height = shareContent.clientHeight * scale + "px";
                canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
                let opts = {
                    scale: scale, // 添加的scale 参数
                    logging: false, //日志开关，便于查看html2canvas的内部执行流程
                    useCORS: true, // 【重要】开启跨域配置
                };
                html2canvas(shareContent,opts).then(canvas => {
                    var contentWidth = canvas.width;
                    var contentHeight = canvas.height;
                    //一页pdf显示html页面生成的canvas高度;
                    var pageHeight = (contentWidth / 592.28) * 841.89;
                    //未生成pdf的html页面高度
                    var leftHeight = contentHeight;
                    //页面偏移
                    var position = 0;
                    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                    var imgWidth = 595.28;
                    var imgHeight = 841.89;
                    var pageData = canvas.toDataURL("image/jpeg", 1.0);
                    var PDF = new JsPDF("", "pt", "a4");
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                PDF.addPage();
                            }
                        }
                    }
                    PDF.save(this.ticketForm.name + "的准考证.pdf"); // 这里是导出的文件名
                    loading.close();
                });
				        this.saveItem(1);
            },
            exportWord() {
                axios({
                    url: `${home}/sysExamRoom/exportWord/-1`,
                    method: "GET",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, new Date().getFullYear()+"年湖北省普通高等学校专升本考试考生准考证.docx");
                });
            },
              saveItem(type){
                  axios({
                      url:`${home}/sysTicketItem/saveSysTicketItems/${type}`,
                      method:'GET',
                  }).then(res=>{
                  }).catch(function (error) {
                      console.log(error);
                  });
              },
        }
    }
</script>
<style lang="scss" scoped>
    tr{
        height: 40px;
    }
    td{
        width: 80px;
    }
    th{
        width: 60px;
    }
    .titleTicket{
        width: 100%;height: 60px;line-height: 60px;
    }
    .titleSpan{
        color: #000;font-size: 18px;font-weight: bold
    }
</style>
<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }

    .page {
        width: 21cm;
        min-height: 29.5cm;
        padding: 2cm;
        margin: auto;
        border-radius: 5px;
        background: white;
    }


    .pageStyle {
        float: left;
        height: 275px;
        width: 46%;
        margin-top: 45px;
        margin-left: 30px;
    }
    .schoolProcessList {
        margin-top: 20px;
        list-style: none;
        // height: 100%;
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        margin-left: -4%;
        // margin-top: -5%;
        // align-content: space-around;
        li {
            border-radius: 6px;
            background: #e8f1fb;
            margin-left: 4%;
            // margin-top: 5%;
            width: 12.6%;
            text-align: center;
            margin-bottom: 4%;
            img {
                margin: 12% auto 10%;
                width: 55%;
            }
            .oa-btn .el-button {
                min-width: 60%;
                max-width: 90%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-left: 5%;
                padding-right: 5%;
                margin-bottom: 18%;
                border-radius: 60px;
                padding-top: 4.5%;
                padding-bottom: 4.5%;

            }
        }
    }

</style>
